/**
 * Project-wide feature flags. Read from Vite env at build time so they tree-shake
 * cleanly. Default to `false` for any flag that gates a system permission dialog
 * or an unfinished feature — we never surface OS prompts (push, etc.) until the
 * backing feature is actually wired.
 *
 * To enable, set in `.env.production` (or `.env.local`):
 *   VITE_PUSH_ENABLED=true
 */

const flag = (name: string): boolean => {
  // import.meta.env values are strings or undefined.
  const v = (import.meta.env as Record<string, string | undefined>)[name];
  return v === 'true' || v === '1';
};

/**
 * PUSH_ENABLED — gates ALL push-notification registration paths (native APNs/FCM
 * + Web Push + the in-app "Never miss a call" banner). Keep `false` until there
 * is a real elefa-to-elefa push payload to deliver. Surfacing the OS permission
 * dialog without a working push feature erodes user trust and triggers App
 * Store review questions about permission justification.
 */
export const PUSH_ENABLED = flag('VITE_PUSH_ENABLED');
